


































































































































import { Component, Mixins } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";

@Component({
  components: {},
  computed: {},
  methods: {}
})
export default class SliderModule extends Mixins(GlobalMixin) {
  carousel = 0;
  information = [
    {
      content: [
        "The MOS dashboards are a powerful compass to assess performance, monitor activities, and facilitates decision making. It allows an in-depth view of mining operations and boasts a large variety of centralized information formats: combo chats, dynamic tables with scrolling on a date, pit, etc)."
      ]
    },
    {
      content: [
        "The MOS reports module centralizes & processes data to highlight the key information. MOS reports provide a comprehensive and exhaustive overview of the activities of the different mines by delivering an array of automated customized reports. "
      ]
    }
  ];
  titles = ["MOS Dashboards", "MOS Reports"];
  images = ["home/mosDashboard.svg", "home/reports.svg"];
}
